import MuiCheckbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import { mainColor, UNIT } from '../../constants'

const CustomCheckbox = withStyles(() => ({
  root: {
    paddingRight: UNIT * 0.625,
    marginLeft: -UNIT * 0.625,
  },
  checked: {
    color: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 1) !important`,
  },
}))(MuiCheckbox);

const Checkbox = props => {
  const { onClick = null, value = false, name, text, className, disabled = false, hidden } = props;

  const handleAction = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
    } else if (onClick) {
      onClick(e);
    }
  };

  const color = disabled ? 'gray' : 'inherit'
  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={value}
      style={{
        display: hidden ? 'none' : 'flex',
        alignItems: 'center',
        height: UNIT * 2.18,
        paddingTop: UNIT * 0.625,
        padding: 0,
        margin: 0,
        border: 'none',
        background: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        color,
        width: '100%',
        textAlign: 'left',
      }}
      className={`w-100 ${className}`}
      onClick={handleAction}
      id={name}
    >
      <CustomCheckbox
        checked={value}
        value={value}
        id={name}
        name={name}
        disabled={disabled}
      />
      <span
        style={{
          marginLeft: UNIT * 0.5,
           color,
        }}
      >
        {text}
      </span>
    </button>
  );
};

export default Checkbox;